import React from "react";

const useDetectClickOutside = (
  targetRef: React.RefObject<HTMLDivElement>,
  outstideClickHandler: (event: Event) => void,
) => {
  React.useEffect(
    () => {
      const clickListener = (event: Event) => {
        if (
          targetRef
          && targetRef.current
          && !targetRef.current.contains(event.target as Node)
        ) {
          outstideClickHandler(event);
        }
      };

      document.addEventListener("mousedown", clickListener);
      document.addEventListener("touchstart", clickListener);

      return () => {
        document.removeEventListener("mousedown", clickListener);
        document.removeEventListener("touchstart", clickListener);
      };
    },
    [targetRef, outstideClickHandler]
  );
};

export default useDetectClickOutside;
